// extracted by mini-css-extract-plugin
export default {"BigTexts":"FinalRejected_BigTexts__u5BUn","text":"FinalRejected_text__uh1bV"};